export const uniqid = (prefix = "", moreEntropy = false) => {
    const c = Date.now() / 1000;
    let d = c.toString(16).split(".").join("");
    while (d.length < 14)
        d += "0";
    let e = "";
    if (moreEntropy) {
        e = ".";
        e += Math.round(Math.random() * 100000000);
    }
    return prefix + d + e;
};
export const stripHtml = (originalString) => {
    return originalString ? originalString.replace(/(<([^>]+)>)/gi, "") : '';
};
